/**
 * Logs an error to error monitoring provider.
 * Logging wrapper - currently sends to raygun but should be able to swap for any provider.
 */
type logErrorHandler = (value: { error: Error; customData?: unknown; tags?: string[] }) => void;
export const logError: logErrorHandler = ({ error, customData, tags }) => {
    // guard against raygun not being available
    if (typeof window.rg4js !== 'function') {
        return;
    }
    // send to raygun
    window.rg4js('send', {
        error,
        customData,
        tags: ['MonitoredError', ...(tags ?? [])],
    });
};
